export const targets = [
  { id: "0", name: "전체" },
  { id: "1", name: "그룹" },
  { id: "2", name: "개인" },
];
